module.exports = __webpack_public_path__ + "img/fa-regular-400.20af3d0e.svg";